import request from '@/api/config.js'

// Добавление сотрудника. В Network: create-employee
export function createEmployee(data) {
  return request({
    url: `employee/create-employee`,
    method: 'post',
    data,
  })
}

// Получение списка всех сотрудников
export function getAllEmployees() {
  return request({
    url: `employee`,
    method: 'get',
  })
}

// Получение одного сотрудника по ID
export function getEmployeeById(id) {
  return request({
    url: `employee/${id}`,
    method: 'get',
  })
}

// Список сотрудников организации (для выбора руководителя и др.). В Network: employees-list
export function getOrgEmployees(id) {
  return request({
    url: `employee/org/${id}/employees-list`,
    method: 'get',
  })
}

// Обновление данных о сотруднике. В Network: update-employee
export function updateEmployee(id, data) {
  return request({
    url: `employee/${id}/update-employee`,
    method: 'put',
    data,
  })
}

// Удаление сотрудника вместе с его аккаунтом. В Network: delete-employee
export function deleteEmployee(id) {
  return request({
    url: `employee/${id}/delete-employee`,
    method: 'delete',
  })
}

// Приглашение сотрудника в систему: создание аккаунта + письмо с временным паролем. В Network: invite
export function inviteEmployee(id) {
  return request({
    url: `employee/${id}/invite`,
    method: 'post',
  })
}

// Повторное письмо с новым паролем через прежний адрес API. В Network: regenerate-access
export function regenerateEmployeeAccess(id) {
  return request({
    url: `employee/${id}/regenerate-access`,
    method: 'post',
  })
}

// Отключение учетной записи без удаления сотрудника. В Network: disable-access
export function disableEmployeeAccess(id) {
  return request({
    url: `employee/${id}/disable-access`,
    method: 'post',
  })
}

// Повторное письмо с новым временным паролем. В Network: resend-access-email
export function resendEmployeeAccessEmail(id) {
  return request({
    url: `employee/${id}/resend-access-email`,
    method: 'post',
  })
}

// Статус последнего письма и время до повторной отправки. В Network: access-email-status
export function getEmployeeAccessEmailStatus(id) {
  return request({
    url: `employee/${id}/access-email-status`,
    method: 'get',
  })
}
